import {
  Component,
  FreeText,
  Kind,
} from "@/services/backend/vbs/treatments/types/component";
import { SegmentKind } from "@/services/backend/vbs/treatments/types/segmentKind";
import { Formula } from "@/services/backend/vbs/treatments/types/formula";
import t from "@/lang/lang";

export interface Position {
  id: string;
  number: string;
  component: Component;
  cycle: number;
  segmentKind: SegmentKind;
  area: string;
  comment: string;
  formula: Formula;
  cleanTime: number;
  basePrice: number;
  cycleDiscountActive: boolean;
  cycleDiscountPercentage: number;
  specialDiscountActive: boolean;
  specialDiscountAmount: number;
  finalPrice: number;
  actuallyTreated: Component;
  completed: boolean;
  completedAt: string;
  immutable: boolean;
  immutabilityReason: string;
}

/**
 * positionTitle returns the fitting title for a position.
 * For some component kinds simply stating the kind is not
 * enough.
 * @param position
 */
export function positionTitle(position: Position): string {
  switch (position.component.kind) {
    case Kind.FreeText:
      return (position.component.data as FreeText).text;
    default:
      return t(position.component.kind);
  }
}
